var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgVipIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.932 15.347h2.01l2.513-11.221-4.678 2.065c.306.413.494.922.494 1.482 0 1.355-1.062 2.454-2.372 2.454-1.31 0-2.37-1.099-2.37-2.454 0-.908.482-1.692 1.19-2.116L19.4 0l-3.322 5.557a2.458 2.458 0 0 1 1.192 2.116c0 1.355-1.062 2.454-2.372 2.454-1.31 0-2.371-1.099-2.371-2.454 0-.56.188-1.07.493-1.482L8.342 4.126l2.513 11.22h2.01",
    fill: "#708FBC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.946 22.574 8.739 36.973H7.135L3.928 22.574m16.136 0v14.399m-3.307.1h6.414m-6.414-14.326h6.414m1.713-.073 2.742.073m5.167-.173c1.771 0 3.207 1.79 3.207 4 0 2.209-1.436 4-3.207 4h-4.811v-8zm-4.71 8v6.399M.72 22.674h6.414m1.604 0h6.414m9.622 14.399h6.414",
    stroke: "#708FBC",
    strokeWidth: 3.202
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgVipIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/vip-icon.56100dbf.svg";
export { ForwardRef as ReactComponent };